import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import { RailResponse, RailStaffReview } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { useRailNavigation } from '@/composables/useRailNavigation';
import { useCMSItemNavigation } from '@/composables/useCMSItemNavigation';
import { IconStar, IconStaffPick } from '@/components/icons';
import TG4Image from '@/components/TG4Image.vue';

/** `rating` is unbounded upstream, so it cannot be trusted to be a star count. */

export default /*#__PURE__*/_defineComponent({
  __name: 'StaffReviewRail',
  props: {
    rail: null,
    railIndex: null,
    railDidNavigateDown: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
  railIndex: number;
  railDidNavigateDown?: (railIndex: number) => void;
};


const MAX_STARS = 5;



const { itemId, handleUp, handleDown, handleLeftFallback } = useRailNavigation(props);
const { openItem } = useCMSItemNavigation();

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const isIrish = computed(() => currentLanguage.value === Language.Irish);

const EMPTY_REVIEW: RailStaffReview = {
  titleEn: '',
  titleGa: '',
  reviewEn: '',
  reviewGa: '',
  rating: null,
  authorImageUrl: null,
  showStaffPickIcon: false,
};

const review = computed(() => props.rail.staffReview ?? EMPTY_REVIEW);

const reviewTitle = computed(() =>
  (isIrish.value ? review.value.titleGa : review.value.titleEn) || review.value.titleEn
);

const reviewBody = computed(() =>
  (isIrish.value ? review.value.reviewGa : review.value.reviewEn) || review.value.reviewEn
);

const stars = computed(() => {
  const rating = review.value.rating ?? 0;
  const count = Math.min(MAX_STARS, Math.max(0, Math.floor(rating)));
  return Array.from({ length: count }, (_unused, index) => index);
});

const paneStyle = computed(() => ({
  'background-color': props.rail.backgroundColor ?? undefined,
  color: props.rail.textColor ?? undefined,
}));

const isBackgroundPink = computed(() => props.rail.backgroundColor === '#FF126C');

const handlePress = () => {
  const item = props.rail.items[0];
  if (item) openItem(item);
};

const rootRef = ref<HTMLElement | null>(null);
const lazyLoad = getCurrentInstance()?.proxy?.$lazyLoad;

const scanForLazyImages = () => {
  setTimeout(() => {
    if (rootRef.value) lazyLoad?.(rootRef.value);
  }, 200);
};

onMounted(scanForLazyImages);


return { __sfc: true,MAX_STARS, props, itemId, handleUp, handleDown, handleLeftFallback, openItem, useGetter, currentLanguage, isIrish, EMPTY_REVIEW, review, reviewTitle, reviewBody, stars, paneStyle, isBackgroundPink, handlePress, rootRef, lazyLoad, scanForLazyImages, IconStar, IconStaffPick, TG4Image }
}

})